import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MessageDialogComponent } from "../system-utils/message-dialog/message-dialog.component";
import { SearchDialogComponent } from "../system-utils/search-dialog/search-dialog.component";
import { UntypedFormGroup } from "@angular/forms";
import { columnsDef } from "../interfaces/columnsDef";
import { OptionDialogComponent, OptionDialogItens } from "../system-utils/option-dialog/option-dialog.component";
import { ESCAPE } from "@angular/cdk/keycodes";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  public width: string = "fit-content";
  public disableClose: boolean = false;
  public btnSim: string = "Sim";
  public btnNao: string = "Não";
  public errorDialoag: boolean = false;
  public status: string = "0";
  public infoDialog: boolean = false;
  public title: string = "";
  //public widthPopUp:string='50vw';

  openDialog(
    msg: String,
    component?: any,
    functionOnOk?: (component: any) => void,
    functionOnCancel?: (component: any) => void
  ): void {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: this.width,
      height: "fit-content",
      maxWidth: "50vw",
      panelClass: "confirm-dialog-container",
      data: {
        message: msg,
        btnSim: this.btnSim,
        btnNao: this.btnNao,
        errorDialog: this.errorDialoag,
        component: component,
        status: this.status,
        infoDialog: this.infoDialog,
        title: this.title,
      },
      disableClose: this.disableClose,
      position: {
        top: "40px",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        if (functionOnOk != null) {
          functionOnOk.call(this, component);
        }
      } else {
        if (functionOnCancel != null) {
          functionOnCancel.call(this, component);
        }
      }
    });
  }

  openNewDialog(
    msg: String,
    functionOnOk?: (data) => void,
    functionOnCancel?: (data) => void,
    error: boolean = false
  ): void {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: this.width,
      height: "fit-content",
      maxWidth: "50vw",
      panelClass: "confirm-dialog-container",
      data: {
        message: msg,
        btnSim: this.btnSim,
        btnNao: this.btnNao,
        errorDialog: error,
        title: this.title,
      },
      disableClose: this.disableClose,
      position: {
        top: "20px",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.title = null;
      if (result == true) {
        if (functionOnOk != null) {
          functionOnOk.call(this, result);
        }
      } else {
        if (functionOnCancel != null) {
          functionOnCancel.call(this, result);
        }
      }
    });
  }


  openOptionDialog(
    title: String,
    items:OptionDialogItens[],
    functionOnOk?: (data) => void,
    functionOnCancel?: (data) => void,
    width:string='200px',
    top:string='120px',
    maxWidth:string='50vw'
  ): void {
    const dialogRef = this.dialog.open(OptionDialogComponent, {
      width: width,
      height: "fit-content",
      maxWidth: maxWidth,
      panelClass: "confirm-dialog-container",
      data: {
        items: items,
        btnSim: this.btnSim,
        btnNao: this.btnNao,
        title: title,
      },
      disableClose: this.disableClose,
      position: {
        top: top,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.title = null;
      if (result) {
        if (functionOnOk != null) {
          functionOnOk.call(this, result);
        }
      } else {
        if (functionOnCancel != null) {
          functionOnCancel.call(this, result);
        }
      }
    });

  }

  openGenericDialog(
    component: any,
    data: Object,
    functionOnOk?: (value: string) => void,
    functionOnCancel?: () => void,
    height?: string,
    width?: string,
    disableClose?: boolean,
    fatherComponent?: any,
    disableMax?: string,
    position?:string,
    functionOnBackDrop?:(data)=>void
  ) {
    const dialogRef = this.dialog.open(component, {
      width: width != null ? width : "50vw",
      height: height != null ? height : "fit-content",
      maxHeight: disableMax == "S" ? "" : "70vh",      
	    maxWidth: "100vw",
      data,
      disableClose: disableClose,
      position: {
        top: position==null?"120px":position,
      },
      panelClass: "generic-dialog-container",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (functionOnOk != null) {
          if (fatherComponent != null) {
            functionOnOk.call(fatherComponent, result);
          } else {
            functionOnOk.call(this, result);
          }
        }
      } else {
        if (functionOnCancel != null) {
          functionOnCancel.call(this);
        }
      }
    });

    dialogRef.backdropClick().subscribe((mouseEvent:MouseEvent)=>{
      if (functionOnBackDrop != null) {
        functionOnBackDrop.call(this, mouseEvent); 
      }
    });

    dialogRef.keydownEvents().subscribe((keyBoard:KeyboardEvent)=>{
      if (functionOnBackDrop != null && keyBoard.keyCode === ESCAPE) {
        functionOnBackDrop.call(this, keyBoard); 
      }
    });
  }

  openFindDialog(
    entityName: string,
    entityDesc: string,
    component: any,
    group: UntypedFormGroup,
    configRef: columnsDef,
    functionOnOk?: (value: string) => void,
    customCondition?: string
  ) {
    const dialogRef = this.dialog.open(SearchDialogComponent, {
      //width : "30vw",
      //height : "80vh",
      maxHeight: "120vh",
      minWidth: "80vw",
      maxWidth: "80vw",
      panelClass: "search-dialog-container",
      data: {
        btn1: "Pesquisar",
        btn2: "Cancelar",
        entityName: entityName,
        entityDesc: entityDesc,
        group: group,
        configRef: configRef,
        component: component,
        customCondition: customCondition,
      },
      disableClose: this.disableClose,
      position: {
        top: "40px",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (functionOnOk != null) {
          functionOnOk.call(this, result);
        }
      }
    });
  }
}
